import React from "react";
import {TEAM_DATA} from "data/constants";
import {Box, css} from "@mui/material";
import {SponsorType} from "data/enums";
import {buildTrackLink} from "data/utils/connextra";
import {first, size} from "lodash";
import styled from "@emotion/styled";

const EmptyWrapp = styled(Box)<IProps>`
	width: ${({width}) => width};
	height: ${({height}) => height};
	background: hotpink;
	display: flex;
	justify-content: center;
	align-items: center;
	padding: 5px 10px;
	color: #2b2b2b;
	text-align: center;
	font-family: var(----fontFamilySecond);
	font-size: 12px;
	font-style: normal;
	font-weight: 700;
	line-height: 120%; /* 14.4px */
	letter-spacing: 0.2px;
	text-transform: uppercase;
`;

const SponsorWrapp = styled(Box)<IProps>`
	width: ${({width}) => width};
	height: ${({height}) => height};
	display: flex;
	justify-content: center;
	align-items: center;

	a {
		display: flex;
		justify-content: center;
		align-items: center;
		width: 100%;
	}

	img {
		display: flex;
		width: 90%;
	}
`;

const SponsorMobileWrapp = styled(Box)<IProps>`
	display: flex;
	justify-content: center;
	align-items: center;

	a {
		display: flex;
		justify-content: center;
		align-items: center;
		width: 100%;
	}
`;

const Image = styled.img<{minWidth?: string; maxWidth?: string}>`
	display: none;
	--minWidthBanner: "0px";
	--maxWidthBanner: "100%";
	max-width: 100%;
	margin: 0 auto;
	${(props) =>
		props.minWidth &&
		css`
			@media (min-width: ${props.minWidth}) and (max-width: ${props.maxWidth}) {
				display: block;
			}
		`};
`;

interface IProps {
	width?: string;
	height?: string;
	type?: SponsorType;
}

export const SponsorLogo: React.FC<IProps> = ({width, height, type = SponsorType.LOGO}) => {
	const hasSponsor = TEAM_DATA.sponsorData?.sponsorLink;

	const image = {
		[SponsorType.LOGO]: TEAM_DATA.sponsorData?.sponsorLogo,
		[SponsorType.LOGO_HEADER]: TEAM_DATA.sponsorData?.sponsorLogoHeader,
		[SponsorType.LOGO_ALT]: TEAM_DATA.sponsorData?.sponsorLogoAlt,
		[SponsorType.LOGO_CHIPS]: TEAM_DATA.sponsorData?.chipsLogo,
		[SponsorType.MAIN_BANNER]: TEAM_DATA.sponsorData?.mainBanner,
		[SponsorType.SECOND_BANNER]: TEAM_DATA.sponsorData?.secondBanner,
		[SponsorType.MOBILE_BANNER]: first(TEAM_DATA.sponsorData?.mobileBanner)?.image,
	}[type];

	const link = {
		[SponsorType.LOGO]: TEAM_DATA.sponsorData?.sponsorLink,
		[SponsorType.LOGO_HEADER]: TEAM_DATA.sponsorData?.sponsorLink,
		[SponsorType.LOGO_ALT]: TEAM_DATA.sponsorData?.sponsorLink,
		[SponsorType.LOGO_CHIPS]: TEAM_DATA.sponsorData?.sponsorLink,
		[SponsorType.MAIN_BANNER]: TEAM_DATA.sponsorData?.mainBannerLink,
		[SponsorType.SECOND_BANNER]: TEAM_DATA.sponsorData?.secondBannerLink,
		[SponsorType.MOBILE_BANNER]: TEAM_DATA.sponsorData?.mobileBannerLink,
	}[type];

	if (!image) {
		return null;
	}

	if (!hasSponsor) {
		return (
			<EmptyWrapp width={width} height={height}>
				Sponsor
			</EmptyWrapp>
		);
	}

	if (type === SponsorType.MOBILE_BANNER && size(TEAM_DATA.sponsorData?.mobileBanner) > 1) {
		return (
			<SponsorMobileWrapp>
				<a href={buildTrackLink(link)} target="_blank" rel="noreferrer">
					{TEAM_DATA.sponsorData?.mobileBanner?.map((image, key) => (
						<Image
							minWidth={image.appearance?.minWidth}
							maxWidth={image.appearance?.maxWidth}
							src={image.image}
							alt="sponsor_logo"
							key={key}
						/>
					))}
				</a>
			</SponsorMobileWrapp>
		);
	}
	return (
		<SponsorWrapp width={width} height={height}>
			<a href={buildTrackLink(link)} target="_blank" rel="noreferrer">
				<img src={image} alt="sponsor_logo" />
			</a>
		</SponsorWrapp>
	);
};
